import { ImgxParams } from './types';

function getUrl<T>(baseUrl: string, newParams?: T & ImgxParams) {
  // Check if no url was provided
  if (!baseUrl) {
    return baseUrl;
  }

  let url = baseUrl;
  // Declare an empty string for query params
  let query = '';
  // Split the url on '?'
  const splitted = url.split('?');
  // Declare an empty object to store params by key
  let params: ImgxParams = {};

  // The base url will be the first part (no params)
  url = splitted[0];
  // If there are any params, store them in the params Object
  if (splitted.length > 1) {
    splitted[1].split('&').forEach(param => {
      const temp = param.split('=');

      params[temp[0]] = temp[1];
    });
  }
  // Add or replace with provided params
  params = {
    ...params,
    ...newParams,
    fit: params.fit || (newParams && newParams.fit) || 'crop',
  };
  // Go through every param (if any) to build the query params
  if (Object.keys(params).length > 0) {
    Object.keys(params).forEach(key => {
      query = query.concat(`${key}=${params[key]}&`);
    });
    // Remove last unnecessary '&'
    query = query.slice(0, query.length - 1);
  }
  // Concat the query params to the url if any
  if (query.length > 0) {
    url = `${url}?${query}`;
  }
  // Return the url built
  return url;
}

export default getUrl;
